module.exports = __webpack_public_path__ + "static/img/header_logo.8991c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/header_logo.png
// module id = Yh1s
// module chunks = 20